import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGoogleLogin } from "@react-oauth/google";
import { Container, Button, Image } from "react-bootstrap";

import "bootstrap/dist/css/bootstrap.min.css";
import "./sign-in-options.css";

import backarrow from "../../assets/images/backarrow.jpg";
import google from "../../assets/images/google 1.jpg";
import logo2 from "../../assets/images/logo2.png";
import responsivebg from "../../assets/images/responsive-bg.png";

import { API_URL } from "../../api";
import { useCookies } from "../../hooks/useCookies";

export const SignInOptions = () => {
  const navigate = useNavigate();
  const cookies = useCookies();
  const [errorMessage, setErrorMessage] = useState("");

  const goToHome = () => window.location.assign("/user/home");

  const login = useGoogleLogin({
    onSuccess: async ({ access_token }) => {
      try {
        const userInfoRes = await fetch(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: { Authorization: `Bearer ${access_token}` },
          }
        );
        const userInfo = await userInfoRes.json();

        const loginRes = await fetch(`${API_URL}user/login/email`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: userInfo.email, usingGoogle: true }),
        });

        const result = await loginRes.json();

        if (loginRes.ok && result.Result?.length > 0) {
          const user = result.Result[0];
          cookies.setCookie("token", result.token, 30);
          cookies.setCookie("userId", user.user_id);

          if ([10, 15, 20, 30].includes(user.approval)) {
            cookies.setCookie("Name", user.first_name, 20);
            goToHome();
          } else if (user.approval === 40) {
            if (!user.email) navigate("/emailverify");
            else if (!user.first_name) navigate("/basicdetails");
            else if (!user.gender) navigate("/abtyourself");
            else if (!user.media) navigate("/selfie");
            else if (!user.location_id) navigate("/located");
            else if (!user.religion_id) navigate("/religion");
            else if (!user.study_id) navigate("/edu");
            else if (!user.job_id) navigate("/jobtitle");
            else if (!user.growth_id) navigate("/height");
            else if (!user.personality) navigate("/personality");
            else if (!user.question_answer) navigate("/profile-answers");
            else if (!user.email_verified_at) navigate("/approve");
          } else {
            setErrorMessage("Please signup first.");
          }
        } else {
          setErrorMessage("Login failed. Please try again.");
        }
      } catch (err) {
        setErrorMessage("An error occurred. Please try again.");
      }
    },
    onError: () => setErrorMessage("Google login failed. Please try again."),
  });

  return (
    <div className="signin-options-container">
      <div className="signin-options-bg">
        <Image className="responsive-bg" src={responsivebg} />
      </div>

      <Container className="signin-options-main">
        <Container className="signin-options-content">
          <Container className="logo-progressbar1">
            <Container className="logo-arrow1">
              <Image
                src={backarrow}
                className="backarrow"
                onClick={() => navigate("/")}
              />
              <Image src={logo2} alt="Logo" className="logo1" />
            </Container>
          </Container>

          <Container className="signin-options-text">
            <span>Hi! It's good to see you again.</span>
            <div className="signin-option-btn">
              <Button className="opt1" onClick={() => navigate("/signIn")}>
                Login with phone number
              </Button>
              <Button className="opt2" onClick={() => navigate("/signinemail")}>
                Login with email
              </Button>
            </div>
          </Container>

          <Container className="signin-options-details">
            <Container className="sign-in-or-option">
              <Container className="or-line">
                <div className="line" />
                <span>or</span>
                <div className="line" />
              </Container>

              <button
                className="google-option"
                style={{ backgroundColor: "white" }}
                onClick={login}
              >
                <Image src={google} alt="Google" />
                Login using Google
              </button>

              {errorMessage && (
                <p className="text-danger error-message">{errorMessage}</p>
              )}

              <p>
                New here? Create an account.{" "}
                <a href="./signup" className="signup-signin">
                  Sign Up
                </a>
              </p>
            </Container>
          </Container>
        </Container>
      </Container>
    </div>
  );
};
